import { useState } from "react";
import { testimonials } from "@/mocks/hoobuyData";

export default function TestimonialsSection() {
  const [current, setCurrent] = useState(0);
  const total = testimonials.length;

  const prev = () => setCurrent((c) => (c === 0 ? total - 1 : c - 1));
  const next = () => setCurrent((c) => (c === total - 1 ? 0 : c + 1));

  const t = testimonials[current];

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[700px] mx-auto text-center">
          <p className="text-sm text-foreground-500 font-serif italic tracking-wide">
            (Reviews Verificadas)
          </p>

          <div className="mt-8">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent-100 text-accent-800">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-star-fill text-sm text-amber-500"></i>
              </div>
              <span className="text-sm font-bold">4.9/5</span>
            </div>
          </div>

          <blockquote className="mt-6">
            <p className="text-lg md:text-xl text-foreground-800 font-serif italic leading-relaxed">
              &ldquo;{t.text}&rdquo;
            </p>
          </blockquote>

          <div className="mt-6 flex items-center justify-center gap-3">
            <img
              src={t.avatar}
              alt={t.name}
              className="w-12 h-12 rounded-full object-cover"
            />
            <div className="text-left">
              <p className="text-sm font-semibold text-foreground-950">{t.name}</p>
              <p className="text-xs text-foreground-500">{t.location}</p>
            </div>
          </div>

          <div className="mt-8 flex items-center justify-center gap-3">
            <button
              onClick={prev}
              className="w-10 h-10 flex items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-600 hover:bg-background-100 transition-colors cursor-pointer"
              aria-label="Anterior"
            >
              <i className="ri-arrow-left-s-line text-lg"></i>
            </button>
            <button
              onClick={next}
              className="w-10 h-10 flex items-center justify-center rounded-md bg-foreground-950 text-background-50 hover:bg-foreground-800 transition-colors cursor-pointer"
              aria-label="Próximo"
            >
              <i className="ri-arrow-right-s-line text-lg"></i>
            </button>
          </div>

          <div className="mt-4 flex items-center justify-center gap-2">
            {testimonials.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setCurrent(idx)}
                className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                  idx === current ? "bg-primary-500 w-5" : "bg-background-300"
                }`}
                aria-label={`Review ${idx + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}